<template>
  <div v-if="product" class="currency-field" v-html="formattedCurrency"></div>
</template>

<script>
export default {
  name: 'tablefield-currency',
  props: ['data', 'config', 'product'],
  computed: {
    formattedCurrency() {
      if (this._.isUndefined(this.data) || this.data === null) {
        return '—'
      }
      return this.$options.filters.currency(
        this.data,
        this._.get(this.product, this._.get(this, 'config.decoratorOptions.currencyPath'), 'EUR'),
        this._.get(this.config, 'decoratorOptions.format[4]', 2),
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldCurrency.vue?44fd4444